<template>
  <div class="booking-confirmation">
    <div class="alert alert-success">
      Your upcoming {{ data.booking_type_label }} will be approved shortly. 
    </div>
    <h3 class="wt-bold font-md mb-6 lh-tight">
      Our team is onto it! You will receive a notification with the {{ data.type }} address 24 hours prior to the
      {{ data.type }} date.
      <template v-if="data.type === 'booking'">
        <!-- A final payment of 50% will be processed 72 hours prior to the {{ data.type }} date. -->
      </template>
    </h3>
    <div class="mb-6">
      <p class="lh-std">
        <span class="fg-primary"><b class="wt-bold">{{ data.booking_type_label }} ID:</b> {{ data.listing.space_name }}</span>
        <template v-if="typeof data.listing.address !== 'undefined'">in {{ data.listing.address.label }}</template>
      </p>
    </div>
    <a v-if="$store.getters['user/account']" class="button muted interactive mb-6" @click="goToBookings">
      Take me to my dashboard
    </a>
  </div>
</template>

<script>
import BaseModal from '../Base'

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  methods: {
    goToBookings () {
      this.$store.commit('account/navigateTo', { pane: 'main', page: 'bookings' })
      this.$emit('cancel')
    }
  }
}
</script>
